<template>
    <div>
        <template
            v-for="(property, index) in properties_object"
        >
            <v-divider
                v-if="index !== 0"
                class="mx-4"
            ></v-divider>

            <summary-breakdown
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :key="'property-' + index"
                :small="small"
            ></summary-breakdown>
        </template>

        <v-divider></v-divider>

        <template
            v-for="(property, index) in properties"
        >
            <summary-value
                :key="index"
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :small="small"
                :greyed="isGreyed(property)"
                :inverted="isInverted(property)"
            ></summary-value>

            <v-divider></v-divider>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import HomeVantageMixin from "../../homevantage";

    export default {
        name: 'HomeVantage-Summary-Summary',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            HomeVantageMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                properties_object: [],
                properties: [
                    'totalValueOfHomeVantage'
                ],
            }
        },

        mounted() {
            this.setPropertyObjects();
        },

        methods: {
            setPropertyObjects() {
                this.properties_object = [
                    {
                        'label': 'Interests saving from origination',
                        'values': [
                            'savingsByShoppingAround',
                        ]
                    },
                ];

                if (true || this.client.best_advantage === 1) {
                    this.properties_object.push(
                        {
                            'label': 'HomeStarter™ Benefit',
                            'values': [
                                'finalHomeStarterBenefit',
                            ]
                        }
                    );
                }

                if (true || this.client.best_advantage === 2) {
                    this.properties_object.push(
                        {
                            'label': 'Bond Accelerator Benefit',
                            'values': [
                                'finalBondAcceleratorBenefit',
                            ]
                        }
                    );
                }

                this.properties_object.push(
                    {
                        'label': 'Saving on deceased estate fees',
                        'values': [
                            'selectedExecutorAndConveyanceFeeIndemnfication',
                        ]
                    }
                );
            },

            isGreyed(property) {
                return property === 'fake';
            },
            isInverted(property) {
                return property === 'totalValueOfHomeVantage';
            }
        }
    }
</script>
